import {
  FooterWrap,
  FooterInner,
  TopRow,
  LogoBox,
  BrandText,
  Socials,
  SocialLink,
  Divider,
  LinksRow,
  Credit,
} from "./FooterStyles";
import Logo from "../../assets/images/Logo.png";
import { FaFacebookF } from "react-icons/fa";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <FooterWrap>
      <FooterInner>
        <TopRow>
          <LogoBox>
            <img src={Logo} alt={t("brand")} />
            <BrandText>{t("brandFull")}</BrandText>
          </LogoBox>

          <Socials>
            <span>{t("footer.follow")}</span>
            <SocialLink
              href="https://www.facebook.com/pizzerie.predeal"
              target="_blank"
              rel="noreferrer"
            >
              <FaFacebookF />
            </SocialLink>
          </Socials>
        </TopRow>

        <Divider />

        <LinksRow>
          <a href="https://anpc.ro/">{t("footer.legal.anpc")}</a> |{" "}
          <a href="https://www.dataprotection.ro/">{t("footer.legal.gdpr")}</a>{" "}
          | <a href="/politica">{t("footer.legal.policy")}</a> |{" "}
          <a href="/termeni">{t("footer.legal.terms")}</a> |{" "}
          <a href="/cookies">{t("footer.legal.cookies.title")}</a>
        </LinksRow>

        <Credit>
          © {new Date().getFullYear()} {t("brand")}. {t("footer.rights")} <br />
          {t("footer.made")}
        </Credit>
      </FooterInner>
    </FooterWrap>
  );
}
